module.exports = __webpack_public_path__ + "static/media/9.36ad922b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/07/projects/01/9.jpg
// module id = 426
// module chunks = 0